import { EMPTY_TEXT_NA } from '../../../../../utils/constants'
import './licenseInfoRowStyles.scss'

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export const LicenseInfoRow = ({ name, value }) => {
  return (
    <>
      <div className='license-info-row-text license-info-row-name'>{name}</div>
      <div className='license-info-row-text'>{value || EMPTY_TEXT_NA}</div>
    </>
  )
}
